import React, { ComponentProps } from 'react';
import { FooterLink } from '../../components/molecules/FooterLink/FooterLink';
import { AnnouncementList } from './partials/AnnouncementList/AnnouncementList';
import { useSonTranslation } from '../../translation/useSonTranslation';
import { asFetchableBlock } from '../../_lib/BlockFetcher';
import { BlockType } from '../../types/api/ElementType';
import { AnnouncementProps } from './Announcement.types';

type AnnouncementsContext = {
  showAllUrl?: string;
  announcements: AnnouncementProps[];
};

function AnnouncementsContext({ announcements, showAllUrl }: AnnouncementsContext) {
  const { t } = useSonTranslation('Announcement');

  return (
    <>
      <AnnouncementList announcements={announcements} />
      {showAllUrl && <FooterLink footerButtonLabel={t('toAllAnnouncements')} footerLink={{ url: showAllUrl }} />}
    </>
  );
}

type CurrentAnnouncementBlockTypes =
  | BlockType.currentmandatoryannouncementsforpage
  | BlockType.currentannouncementsoutbox
  | BlockType.currentannouncementsinbox;

export const AnnouncementsContextBlock = asFetchableBlock<AnnouncementsContext, CurrentAnnouncementBlockTypes>(
  AnnouncementsContext,
);
export type AnnouncementsContextBlock = ComponentProps<typeof AnnouncementsContextBlock>;
